module.exports = __webpack_public_path__ + "static/Example-fc7d7b5ea6d322ed3854b923c561e07c.mp4";